var map = {
	"./aparthotelclub/ic_tag_entry.png": 14314,
	"./beachful/ic_tag_entry.png": 45898,
	"./castlepedia/ic_tag_entry.png": 87372,
	"./cocktayl/ic_tag_entry.png": 89129,
	"./ic_tag_entry.png": 32530,
	"./luxresortclub/ic_tag_entry.png": 47243,
	"./parkful/ic_tag_entry.png": 38236,
	"./prefabworld/ic_tag_entry.png": 96648,
	"./rooftopclub/ic_tag_entry.png": 99706,
	"./spaclub/ic_tag_entry.png": 82038,
	"./worldcasino/ic_tag_entry.png": 78970,
	"./zoopedia/ic_tag_entry.png": 62087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54761;